import { globals, priceAndPointConverter } from 'common-ui';
import type { ProductCardProps } from './ProductCard';
import { PricePerLitre } from '../PricingAndPurchasePanel/components/Shared/PricePerLitre';

const ProductCardPrice = (props: ProductCardProps) => {
  const {
    productPrice,
    productPriceOriginal,
    productNumberOfBottles,
    productMemberPrice,
    memberPricePerLitre,
    salesPricePerLitre,
  } = props || {};

  const hasSalePrice = productPrice !== null && productPrice !== undefined;
  const hasRetailPrice =
    productPriceOriginal !== null && productPriceOriginal !== undefined && productPriceOriginal !== 0;
  const shouldShowOriginalPrice = hasSalePrice && hasRetailPrice && productPriceOriginal > productPrice;

  let displayPrice: number | null = null;
  if (hasSalePrice) {
    displayPrice = productPrice;
  } else if (hasRetailPrice) {
    displayPrice = productPriceOriginal;
  }

  return (
    <>
      <div className="product-price body1">
        {productNumberOfBottles && productNumberOfBottles !== 0 ? (
          <span className="product-card__bottles">
            {productNumberOfBottles} bottle{`${productNumberOfBottles > 1 ? 's :' : ' :'}`}
          </span>
        ) : (
          ''
        )}
        {displayPrice !== null && displayPrice !== undefined && (
          <>
            {shouldShowOriginalPrice ? (
              <span className="product-price__original strikeThrough">
                {priceAndPointConverter(productPriceOriginal)}
              </span>
            ) : null}
            <span className="body1 bold">{priceAndPointConverter(displayPrice)}</span>
            {salesPricePerLitre && (
              <PricePerLitre price={displayPrice} bottleVolume={productNumberOfBottles || undefined} />
            )}
          </>
        )}
      </div>

      {productMemberPrice && productMemberPrice !== 0 ? (
        <span className="product-card__member-price body1 bold">
          {priceAndPointConverter(productMemberPrice)} {globals?.brandId === 'wsj' ? 'Advantage' : 'Unlimited'} Member
          Price
          {memberPricePerLitre && <PricePerLitre pricePerLitre={memberPricePerLitre} />}
        </span>
      ) : (
        ''
      )}
    </>
  );
};

export default ProductCardPrice;
